<file [ngModel]="urlImagen" (ngModelChange)="onChangeFile($event)" [key]="'imagen_' + contestableId"></file>

<loading-layout *ngIf="loading"></loading-layout>
<img *ngIf="!loading && urlImagen" [src]="urlImagenPath" />
